<template>
  <div id="app">
    <div class="city-title" v-if="!$store.state.Counter.noGlobalCity">{{$store.state.Counter.city}}</div>
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        :key="($route.meta.cacheKey || $route.path)"
      ></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  export default {
    created() {
      window._AMapSecurityConfig = { // 高德地图key的密钥
        // securityJsCode:'26aae1482d4391f62dbcc8699ca27e3a', // 苏振龙的
        // securityJsCode:'d4808942a7c0d9237ce9c0cfb8306be8', // 张宁宁的
        // securityJsCode:'42db024fe5d99b6f0506c4b7df80a299', //王向阳的
        // securityJsCode:'05d3881114c66f3d9ddaa7b0212ca635', //盛成伟的
        // securityJsCode:'b20fe227feb5fad486b8857b93536e1e', //赵宇航的
        securityJsCode:'04df960d47a16aca821c9ab04fc3c82a', //金昕涛的
      }
      console.log('APP created');
      if (!this.$store.state.Counter.city) {
        let city = sessionStorage.getItem('city');
        if (city) {
          this.$store.commit('SET_CITY', city);
        }
      }
    }
  }

</script>

<style>
  * {
    padding: 0;
    margin: 0;
  }

  html,
  body {
    width: 100%;
    height: 100%;
  }

  .normal {
    margin: 10px 0;
  }

  .amap-marker-content {
    white-space: nowrap !important;
  }
  
  .stationIcon1 {
    height: 17px;
    width: 17px;
    border-radius: 50%;
    /* background-color: darkgray; */
    padding: 4px;
    box-sizing: border-box;
  }

  .stationIcon1 div {
    height: 9px;
    width: 9px;
    border-radius: 50%;
    background-color: #ffffff;
  }

  .stationIcon2 {
    /* 转换站 */
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: #fff;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .is-horizontal {
    display: none;
  }
  .el-tooltip__popper {
    max-width: 600px;
  }

  .city-title {
    position: fixed;
    right: 0;
    top: 0;
    background-color: #eeeeee;
    z-index: 999;
  }


  .el-tree--highlight-current
  .el-tree-node.is-current>.el-tree-node__content {
    background-color: #cee2ff !important;
  }
  .el-tree-node-text {
    color: #0066ff !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue